/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react'
import { withTranslation } from 'react-i18next'

import './PlaceholderPreviewCard.scss'

class PlaceholderPreviewCard extends React.Component {
  render() {
    const { active, message, removeActive, blockIndex, taskIndex, t } = this.props
    return (
      <div id='PlaceholderPreviewCard'>
        <p className='placeholder-card-message'>{message}</p>
        {active && (
          <p
            className='placeholder-card-action'
            onClick={e => removeActive(e, blockIndex, taskIndex)}
          >
            {t('lessonPlans.placeholderPreviewCard.clickToRemove')}
          </p>
        )}
      </div>
    )
  }
}

export default withTranslation()(PlaceholderPreviewCard)
